// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"67":"75073828","515":"70efa157"}[chunkId] + ".js";
};